module.exports = __webpack_public_path__ + "static/media/hue.25dfb7f2.gif";